/**
 * Ornamentos gravados em SVG — inline, sem dependência externa e sem requisição de rede.
 * Todos são decorativos: ficam fora da árvore de acessibilidade (`aria-hidden`) e não recebem foco.
 */

/** Monograma emoldurado da editora, usado na marca do cabeçalho e no rodapé. */
export function Emblem() {
  return (
    <span className="emblem" aria-hidden="true">
      <svg viewBox="0 0 40 40" focusable="false">
        <rect className="emblem__frame" x="0" y="0" width="40" height="40" rx="3" />
        <rect className="emblem__inner" x="4.5" y="4.5" width="31" height="31" rx="1.5" />
        <text className="emblem__letter" x="20" y="27.5" textAnchor="middle">
          D
        </text>
      </svg>
    </span>
  );
}

/** Filete duplo com losango central — divisor de seção de página impressa. */
export function RuleOrnament() {
  return (
    <div className="rule-ornament" aria-hidden="true">
      <svg viewBox="0 0 12 12" focusable="false">
        <path d="M6 0 L12 6 L6 12 L0 6 Z" />
      </svg>
    </div>
  );
}

const RING_TICKS = Array.from({ length: 60 }, (_, i) => i * 6);
const ROSETTE_PETALS = Array.from({ length: 12 }, (_, i) => i * 30);

/**
 * Medalhão guilhochê: anel graduado e roseta de linhas finas, no espírito das gravuras de
 * certificados e cédulas — a referência visual de integridade e procedência. Gira lentamente
 * (e para por completo quando o sistema pede movimento reduzido).
 */
export function Medallion({ className }: { className?: string }) {
  return (
    <svg className={`medallion ${className ?? ""}`} viewBox="0 0 200 200" aria-hidden="true" focusable="false">
      <g className="medallion__ring">
        {RING_TICKS.map((angle) => (
          <line
            key={angle}
            x1="100"
            y1="8"
            x2="100"
            y2={angle % 30 === 0 ? 22 : 15}
            transform={`rotate(${angle} 100 100)`}
          />
        ))}
        <circle cx="100" cy="100" r="92" />
      </g>
      <circle cx="100" cy="100" r="78" />
      <circle cx="100" cy="100" r="72" />
      <g className="medallion__rosette">
        {ROSETTE_PETALS.map((angle) => (
          <ellipse key={angle} cx="100" cy="100" rx="28" ry="68" transform={`rotate(${angle} 100 100)`} />
        ))}
      </g>
      <circle cx="100" cy="100" r="26" />
    </svg>
  );
}
